export default "__VITE_ASSET__DiIyhCHE__"